import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/admin/members");

export const Route = createFileRoute("/admin/members")({
  head: () => ({
    meta: [
      { title: "Members — LevelLoad" },
      { name: "description", content: "Members — LevelLoad transport planning." },
      { property: "og:title", content: "Members — LevelLoad" },
      { property: "og:description", content: "Members — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
